<div class="sample-padding">
  <ejs-chiplist id="filterChipList" [chips]="chips" (deleted)="chipDeleted($event)" #filterChipList enableDelete="true"
    style="float: left;">
  </ejs-chiplist>
  <button class="btn e-chip e-chip-icon-wrap" (click)="openFilterDialog()" style="float: left;"
    title="{{'i18n.domain.parker-administration.overview.filter-dialog.add-filter-tooltip' | translate}} ">
    <span class="e-btn-icon e-icons icon-add-round e-icon-left"></span>
  </button>
</div>
<ejs-dialog #filterDialog [isModal]="true" [showCloseIcon]="true" [visible]="false">
  <ng-template #header>
    {{'i18n.domain.parker-administration.overview.filter-dialog.title' | translate}}
  </ng-template>
  <ng-template #content>
    <div class="row">
      <div class="col-6">
        <ejs-listbox [dataSource]='filterFieldList' [fields]="fieldList" #fieldsListBox id="fieldsListBox">
          <ng-template #itemTemplate let-data>
            <div >

            </div>
            <div *ngIf="data.i18nLabel" id="data.filterField">
              {{data.i18nLabel | translate}}
            </div>

            <div *ngIf="!data.i18nLabel">
              {{data.displayName | translate}}
            </div>
            <span *ngIf="hasFilter(data.displayName)" class="filterIcon e-icons e-icon-filter e-filtered"></span>
          </ng-template>
        </ejs-listbox>
      </div>
      <div class="col-6">
        <form [formGroup]="filterForm">
          <label class="control-label">{{'i18n.domain.parker-administration.overview.filter-dialog.value-title' |
            translate}} </label>
          <ejs-dropdownlist id="groups" formControlName="Group" formControlName="Group" [dataSource]="groupTypes"
            [fields]="enumDropdownSettings" *ngIf="isTheFieldSelected('Group')"></ejs-dropdownlist>

          <input id="CostCenter" type="text" class="form-control" formControlName="CostCenter"
            *ngIf="isTheFieldSelected('CostCenter')" />

          <input id="Title" type="text" class="form-control" formControlName="Title"
            *ngIf="isTheFieldSelected('Title')" />

          <input id="workplace" type="text" class="form-control" formControlName="Workplace"
            *ngIf="isTheFieldSelected('Workplace')" />

          <input id="employmentPercentage" type="number" class="form-control" formControlName="EmploymentPercentage"
            *ngIf="isTheFieldSelected('EmploymentPercentage')" />

          <app-yes-no-group-button id="IsLinked" formControlName="IsLinked" [allowNull]="true"
            *ngIf="isTheFieldSelected('IsLinked')"></app-yes-no-group-button>

          <app-yes-no-group-button id="Active" formControlName="Active" [allowNull]="true"
            *ngIf="isTheFieldSelected('Active')"></app-yes-no-group-button>

          <app-yes-no-group-button id="Billing" formControlName="Billing" [allowNull]="true"
            *ngIf="isTheFieldSelected('Billing')"></app-yes-no-group-button>

          <app-yes-no-group-button id="HasSubscriptions" formControlName="HasSubscriptions" [allowNull]="true"
            *ngIf="isTheFieldSelected('HasSubscriptions')"></app-yes-no-group-button>

          <ejs-dropdownlist id="Subscription" [dataSource]="subscriptionsDropdownValues" [showClearButton]="true"
            formControlName="Subscription" *ngIf="isTheFieldSelected('Subscription')"
            [fields]="dropdownSettings"></ejs-dropdownlist>

          <input id="Custom1" type="text" class="form-control" formControlName="Custom1"
            *ngIf="isTheFieldSelected(this.client.custom1Name)" />

          <input id="Custom2" type="text" class="form-control" formControlName="Custom2"
            *ngIf="isTheFieldSelected(this.client.custom2Name)" />

          <input id="Custom3" type="text" class="form-control" formControlName="Custom3"
            *ngIf="isTheFieldSelected(this.client.custom3Name)" />

          <input id="Custom4" type="text" class="form-control" formControlName="Custom4"
            *ngIf="isTheFieldSelected(this.client.custom4Name)" />

          <input id="Custom5" type="text" class="form-control" formControlName="Custom5"
            *ngIf="isTheFieldSelected(this.client.custom5Name)" />

          <input id="Custom6" type="text" class="form-control" formControlName="Custom6"
            *ngIf="isTheFieldSelected(this.client.custom6Name)" />

          <input id="Custom7" type="text" class="form-control" formControlName="Custom7"
            *ngIf="isTheFieldSelected(this.client.custom7Name)" />

          <input id="Custom8" type="text" class="form-control" formControlName="Custom8"
            *ngIf="isTheFieldSelected(this.client.custom8Name)" />

          <input id="Custom9" type="text" class="form-control" formControlName="Custom9"
            *ngIf="isTheFieldSelected(this.client.custom9Name)" />
        </form>
      </div>
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <button class="btn btn-secondary me-2" (click)="closeFilterDialog()">
      {{'i18n.domain.parker-administration.overview.filter-dialog.cancel-button' | translate}}
    </button>
    <button class="btn btn-primary" (click)="applyFilter()">
      {{'i18n.domain.parker-administration.overview.filter-dialog.apply-filter-button' | translate}}
    </button>
  </ng-template>
</ejs-dialog>
